import { MessageCircle } from "lucide-react";
import { waHref } from "@/data/site";

export default function WhatsAppFloat() {
  return (
    <a
      href={waHref()}
      target="_blank"
      rel="noreferrer"
      aria-label="WhatsApp ile iletişim"
      data-testid="floating-whatsapp"
      className="fixed bottom-5 right-5 z-40 h-14 md:h-14 md:pl-5 md:pr-6 flex items-center justify-center gap-3 rounded-full bg-[#25D366] text-white wa-pulse transition-transform hover:scale-105"
      style={{ width: "56px" }}
      onMouseEnter={(e) => { e.currentTarget.style.width = "auto"; }}
      onMouseLeave={(e) => {
        if (window.innerWidth < 768) e.currentTarget.style.width = "56px";
      }}
    >
      <MessageCircle size={24} strokeWidth={2} />
      <span className="hidden md:inline text-xs tracking-[0.18em] uppercase font-semibold">Uzmana Danışın</span>
    </a>
  );
}
